import { render, staticRenderFns } from "./SupportRequest.vue?vue&type=template&id=0f92089f&scoped=true"
import script from "../controllers/SupportRequest.ts?vue&type=script&lang=ts&external"
export * from "../controllers/SupportRequest.ts?vue&type=script&lang=ts&external"
import style0 from "./SupportRequest.vue?vue&type=style&index=0&id=0f92089f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92089f",
  null
  
)

export default component.exports